var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "final-ribbon" },
    [
      _c("bulk-download", {
        attrs: {
          "show-bulk-download": _vm.showBulkDownloadModal,
          "checked-assets": _vm.checkedAssets,
        },
        on: {
          close: function ($event) {
            _vm.showBulkDownloadModal = false
          },
        },
      }),
      !_vm.isDataLoaded
        ? _c("eas-loader")
        : _c("div", { staticClass: "flex-container pl-2 pr-2" }, [
            _c("div", { staticClass: "flex-col flex-2" }, [
              _c("div", { staticClass: "flex-row" }, [
                _c("div", { staticClass: "flex-col" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.hideFilterFleet,
                          expression: "hideFilterFleet",
                        },
                      ],
                      staticClass: "flex-row filter pt-1 pl-4",
                    },
                    [
                      _c(
                        "a",
                        {
                          class: [
                            "select-asset",
                            { active: _vm.fleetSelect.isActive },
                          ],
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleFleet()
                            },
                          },
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.$t("selectFleet")) + " "),
                          !_vm.fleetSelect.isActive
                            ? _c("img", {
                                class: [
                                  "triangle ml-1",
                                  { up: _vm.fleetSelect.isExpanded },
                                ],
                                attrs: {
                                  src: require("@/assets/icons/ic-triangle-dropdown@2x.png"),
                                },
                              })
                            : _c("img", {
                                class: [
                                  "triangle ml-1",
                                  { up: _vm.fleetSelect.isExpanded },
                                ],
                                attrs: {
                                  src: require("@/assets/icons/ic-triangle-dropdown-dark@2x.png"),
                                },
                              }),
                        ]
                      ),
                      _c("fade-transition", { attrs: { fast: true } }, [
                        _vm.fleetSelect.isExpanded
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "filter-expand filter-expand--type",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "checkboxFilter" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "checkbox-container" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.fleetSelect.isCheckAll,
                                              expression:
                                                "fleetSelect.isCheckAll",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.fleetSelect.isCheckAll
                                            )
                                              ? _vm._i(
                                                  _vm.fleetSelect.isCheckAll,
                                                  null
                                                ) > -1
                                              : _vm.fleetSelect.isCheckAll,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.checkAllFleet()
                                            },
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.fleetSelect.isCheckAll,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.fleetSelect,
                                                      "isCheckAll",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.fleetSelect,
                                                      "isCheckAll",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.fleetSelect,
                                                  "isCheckAll",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          _vm._s(_vm.$t("selectAll")) + " "
                                        ),
                                        _c("span", {
                                          staticClass: "checkmark",
                                        }),
                                      ]
                                    ),
                                    _vm._l(_vm.fleetList, function (fleet) {
                                      return _c(
                                        "label",
                                        {
                                          key: fleet.sid,
                                          staticClass: "checkbox-container",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.checkedFleets,
                                                expression: "checkedFleets",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              value: fleet.sid,
                                              checked: Array.isArray(
                                                _vm.checkedFleets
                                              )
                                                ? _vm._i(
                                                    _vm.checkedFleets,
                                                    fleet.sid
                                                  ) > -1
                                                : _vm.checkedFleets,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = _vm.checkedFleets,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = fleet.sid,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.checkedFleets =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.checkedFleets = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.checkedFleets = $$c
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.updateCheckallFleet()
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(_vm._s(fleet.name) + " "),
                                          _c("span", {
                                            staticClass: "checkmark",
                                          }),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "done-filter-button mt-1",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.disableDoneFleet(),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.filterChangeFleet()
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("done")) + " ")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "flex-col" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.hideFilter,
                          expression: "hideFilter",
                        },
                      ],
                      staticClass: "flex-row filter pt-1 pl-4",
                    },
                    [
                      _c(
                        "a",
                        {
                          class: [
                            "select-asset",
                            { active: _vm.assetSelect.isActive },
                          ],
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleAsset()
                            },
                          },
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.$t("selectAsset")) + " "),
                          !_vm.assetSelect.isActive
                            ? _c("img", {
                                class: [
                                  "triangle ml-1",
                                  { up: _vm.assetSelect.isExpanded },
                                ],
                                attrs: {
                                  src: require("@/assets/icons/ic-triangle-dropdown@2x.png"),
                                },
                              })
                            : _c("img", {
                                class: [
                                  "triangle ml-1",
                                  { up: _vm.assetSelect.isExpanded },
                                ],
                                attrs: {
                                  src: require("@/assets/icons/ic-triangle-dropdown-dark@2x.png"),
                                },
                              }),
                        ]
                      ),
                      _c("fade-transition", { attrs: { fast: true } }, [
                        _vm.assetSelect.isExpanded
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "filter-expand filter-expand--type",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "checkboxFilter" },
                                  [
                                    _vm.isSelectAllHidden
                                      ? _c(
                                          "label",
                                          { staticClass: "checkbox-container" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.assetSelect.isCheckAll,
                                                  expression:
                                                    "assetSelect.isCheckAll",
                                                },
                                              ],
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.assetSelect.isCheckAll
                                                )
                                                  ? _vm._i(
                                                      _vm.assetSelect
                                                        .isCheckAll,
                                                      null
                                                    ) > -1
                                                  : _vm.assetSelect.isCheckAll,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.checkAllAssets()
                                                },
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.assetSelect
                                                        .isCheckAll,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.assetSelect,
                                                          "isCheckAll",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.assetSelect,
                                                          "isCheckAll",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.assetSelect,
                                                      "isCheckAll",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              _vm._s(_vm.$t("selectAll")) + " "
                                            ),
                                            _c("span", {
                                              staticClass: "checkmark",
                                            }),
                                          ]
                                        )
                                      : _c(
                                          "label",
                                          { staticClass: "no-assets" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("noDataAvailable")
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                    _vm._l(_vm.assets, function (asset) {
                                      return _c(
                                        "label",
                                        {
                                          key: asset.id,
                                          staticClass: "checkbox-container",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.checkedAssets,
                                                expression: "checkedAssets",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              value: asset,
                                              checked: Array.isArray(
                                                _vm.checkedAssets
                                              )
                                                ? _vm._i(
                                                    _vm.checkedAssets,
                                                    asset
                                                  ) > -1
                                                : _vm.checkedAssets,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = _vm.checkedAssets,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = asset,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.checkedAssets =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.checkedAssets = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.checkedAssets = $$c
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.updateCheckallAssets()
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(_vm._s(asset.name) + " "),
                                          _c("span", {
                                            staticClass: "checkmark",
                                          }),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "done-filter-button mt-1",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.disableDone(),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.filterChange()
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("done")) + " ")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "flex-col" }, [
                  _c("div", { staticClass: "flex-row ml-2" }, [
                    _c(
                      "button",
                      {
                        staticClass: "remove-button reset-filter-button",
                        class: { reset: _vm.isResetActive },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.resetFilter()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("resetFilters")) + " ")]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "flex-col flex-1" }, [
              _c("div", { staticClass: "flex-row flex-1 reverse" }, [
                _vm.hasEditAccess
                  ? _c(
                      "div",
                      {
                        staticClass: "flex-col",
                        on: {
                          click: function ($event) {
                            return _vm.toggleReport()
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            class: [
                              "flex-row",
                              "toggler",
                              _vm.isFinalReport ? "reverse" : "",
                            ],
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex-col flex-1 toggle-text" },
                              [_vm._v(_vm._s(_vm.isFinalReport ? "AD" : "RO"))]
                            ),
                            _c("div", {
                              staticClass: "flex-col flex-1 toggle-switch",
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.hasEditAccess && _vm.hasCheckedAsset
                  ? _c("div", { staticClass: "separator" })
                  : _vm._e(),
                _vm.hasEditAccess && _vm.hasCheckedAsset
                  ? _c(
                      "div",
                      { staticClass: "flex-col" },
                      [
                        _c(
                          "adam-button",
                          {
                            staticClass: "download-button",
                            attrs: { secondary: "" },
                            on: { click: _vm.downloadPdf },
                          },
                          [_vm._v(_vm._s(_vm.$t("downloadPdf")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasEditAccess && _vm.hasCheckedAsset
                  ? _c("div", { staticClass: "separator" })
                  : _vm._e(),
                _vm.hasEditAccess && _vm.hasCheckedAsset
                  ? _c("div", { staticClass: "flex-col" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function ($event) {
                              return _vm.openNewPage()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("generateLink")) + " ")]
                      ),
                    ])
                  : _vm._e(),
                _vm.hasViewAccess && _vm.hasCheckedAsset
                  ? _c("div", { staticClass: "flex-col" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          on: { click: _vm.showExportXlsx },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("exportXlsx")) + " ")]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }